import { ArrowLeft, Flag } from "lucide-react";
import { CardButtons } from "@/components/CardButtons";

export const PostMatch = ({ onCard, onBack, onFinish }) => (
  <section data-testid="post-match-panel" className="border border-white/15 bg-[#131313] p-4 sm:p-6 space-y-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <p className="label-caps text-[#FF9F0A]">Jogo concluído</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase">Pós-jogo</h2>
      </div>
      <button data-testid="post-match-back" onClick={onBack} className="tap h-10 px-3 border border-white/15 text-sm flex items-center gap-2 hover:bg-white/5">
        <ArrowLeft size={16} /> Voltar ao jogo
      </button>
    </div>
    <p className="text-sm text-zinc-400">Registe cartões exibidos após o apito final. Quando terminar, carregue em Terminar jogo.</p>
    <CardButtons testPrefix="post-card" onPick={onCard} />
    <button data-testid="post-match-finish" onClick={onFinish}
      className="tap w-full h-14 bg-white text-black font-display text-xl font-bold uppercase flex items-center justify-center gap-2 hover:bg-zinc-200">
      <Flag size={20} /> Terminar jogo
    </button>
  </section>
);
